export type HelpModel = {
	Id: string;
	Name: string;
	Url: string;
	ShowMain: boolean;
};

export enum HelpFeature {
	None = 0,
	Enrollment,
	UnassignedAndGuestCredentials,
	Alarms,
	Events,
	DeviceControl,
	StatusViewer,
	WhosInside,
	PhotoCallUp,
	Reporting,
	StatusDashboard,
	Graphics,
	Badge,
	VelocityVision,
	OperatorMenu,
	CredentialTemplates,
	FunctionGroups,
	Roles,
	NetworkGlobalIoConfiguration,
	ReaderControlGroup,
	DigitracHolidays,
	TimeZones,
	Operators,
	Ports,
	XBoxes,
	Controllers,
	Doors,
	ExpansionInputs,
	ExpansionRelays,
	Readers,
	Inputs,
	Relays,
	CommandSet,
	DoorGroups,
}
